<div class="container mx-auto" *transloco="let t">
  <div class="mb-6">
    <h1 class="text-2xl font-bold flex items-center gap-2">
      {{ t('provider.tenders.title') }}
      @if (!tendersAllResource.isLoading()) {
        <p-badge [value]="allTenders().length" severity="secondary"></p-badge>
      }
    </h1>
  </div>

  @if (tendersAllResource.isLoading()) {
    <app-loading />
  } @else if (tendersAllResource.error()) {
    <div class="text-center py-12">
      <h3 class="text-lg font-semibold mb-2 text-red-500">{{ t('common.error') }}</h3>
      <p>Failed to load tenders</p>
    </div>
  } @else if (allTenders().length === 0) {
    <app-no-data
      label="provider.tenders.noTenders"
      description="provider.tenders.noTendersDescription"
    />
  } @else {
    <p-tabs appTabsUnsavedReveal [value]="activeTabIndex()" data-testid="tender-tabs">
      <p-tablist>
        <p-tab [value]="0" data-testid="in-progress-tab">
          <span class="flex items-center gap-2">
            {{ t('provider.tenders.inProgress') }}
            <p-badge [value]="inProgressTenders().length" severity="info"></p-badge>
          </span>
        </p-tab>

        <p-tab [value]="1" data-testid="successful-tab">
          <span class="flex items-center gap-2">
            {{ t('provider.tenders.successful') }}
            <p-badge [value]="wonTenders().length" severity="success"></p-badge>
          </span>
        </p-tab>

        <p-tab [value]="2" data-testid="lost-tab">
          <span class="flex items-center gap-2">
            {{ t('provider.tenders.lost') }}
            <p-badge [value]="lostTenders().length" severity="danger"></p-badge>
          </span>
        </p-tab>
      </p-tablist>

      <p-tabpanels class="mt-6">
        <p-tabpanel [value]="0">
          <app-data-view-grid
            [items]="inProgressTenders()"
            [emptyMessage]="t('provider.tenders.noInProgressTenders')"
          >
            <ng-template #itemTemplate let-tender>
              <app-tender-card
                [tender]="tender"
                (answerRequest)="onAnswerRequest($event)"
              ></app-tender-card>
            </ng-template>
          </app-data-view-grid>
        </p-tabpanel>

        <p-tabpanel [value]="1">
          <app-data-view-grid
            [items]="wonTenders()"
            [emptyMessage]="t('provider.tenders.noSuccessfulTenders')"
          >
            <ng-template #itemTemplate let-tender>
              <app-tender-card [tender]="tender" />
            </ng-template>
          </app-data-view-grid>
        </p-tabpanel>

        <p-tabpanel [value]="2">
          <app-data-view-grid
            [items]="lostTenders()"
            [emptyMessage]="t('provider.tenders.noLostTenders')"
          >
            <ng-template #itemTemplate let-tender>
              <app-tender-card [tender]="tender" />
            </ng-template>
          </app-data-view-grid>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    @if (selectedTender(); as tender) {
      <app-subcriteria-scores-modal
        [visible]="subcriteriaScoresModalVisible()"
        [toolId]="tender.hrToolDirectusId"
        [projectId]="tender.projectId || 0"
        [phaseType]="tender.activePhaseStatusInfo.phase || TenderPhaseType.RFI"
        [tenantMode]="ScoresModalMode.PROVIDER"
        [tenderId]="tender.tenderMappingId"
        [tenderStatus]="tender.activePhaseStatusInfo.status"
        (visibleChange)="subcriteriaScoresModalVisible.set($event)"
      />
    }
  }
</div>
